module.exports = __webpack_public_path__ + "img/home.145dab18.jpg";